import { alpha, createTheme } from "@mui/material/styles";
import {
  BACKGROUND_DEFAULT,
  BACKGROUND_PAPER,
  BRAND_PRIMARY,
  BRAND_PRIMARY_LIGHT,
  BRAND_SECONDARY,
  BRAND_SECONDARY_LIGHT,
} from "./themePreference";

function buildDarkReadableForeground(color) {
  return {
    color,
    borderColor: color,
    "&:hover": {
      color,
      borderColor: color,
      backgroundColor: alpha(color, 0.12),
    },
    "& .MuiChip-icon": {
      color,
    },
  };
}

function buildDarkComponentOverrides() {
  const primaryForeground = buildDarkReadableForeground(BRAND_PRIMARY_LIGHT);
  const secondaryForeground = buildDarkReadableForeground(BRAND_SECONDARY_LIGHT);

  return {
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: primaryForeground,
        outlinedSecondary: secondaryForeground,
        textPrimary: {
          color: BRAND_PRIMARY_LIGHT,
        },
        textSecondary: {
          color: BRAND_SECONDARY_LIGHT,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        outlinedPrimary: primaryForeground,
        outlinedSecondary: secondaryForeground,
      },
    },
    MuiIconButton: {
      styleOverrides: {
        colorPrimary: {
          color: BRAND_PRIMARY_LIGHT,
        },
        colorSecondary: {
          color: BRAND_SECONDARY_LIGHT,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        colorPrimary: {
          color: BRAND_PRIMARY_LIGHT,
        },
        colorSecondary: {
          color: BRAND_SECONDARY_LIGHT,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        colorPrimary: {
          color: BRAND_PRIMARY_LIGHT,
        },
        colorSecondary: {
          color: BRAND_SECONDARY_LIGHT,
        },
      },
    },
  };
}

export function createAppTheme(mode) {
  const resolvedMode = mode === "dark" ? "dark" : "light";
  const isDark = resolvedMode === "dark";

  return createTheme({
    palette: {
      mode: resolvedMode,
      primary: {
        main: BRAND_PRIMARY,
        ...(isDark ? { light: BRAND_PRIMARY_LIGHT } : {}),
        contrastText: "#ffffff",
      },
      secondary: {
        main: BRAND_SECONDARY,
        ...(isDark ? { light: BRAND_SECONDARY_LIGHT } : {}),
        contrastText: "#ffffff",
      },
      background: {
        default: BACKGROUND_DEFAULT[resolvedMode],
        paper: BACKGROUND_PAPER[resolvedMode],
      },
      text: {
        primary: isDark ? "#ffffff" : "rgba(0, 0, 0, 0.87)",
        secondary: isDark ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.6)",
      },
    },
    typography: {
      fontFamily: ["Roboto", "Arial", "sans-serif"].join(","),
    },
    ...(isDark ? { components: buildDarkComponentOverrides() } : {}),
  });
}
